import { readStoredJson } from '@/utils/storage';

const storedUniverse = readStoredJson('admin_selectedUniverse');
const activeUniverse = storedUniverse && typeof storedUniverse === 'object' && storedUniverse.id
  ? storedUniverse
  : null;

export default {
  universes: [],
  activeUniverse,
  requestStatus: 'loading',
  groups: [],
};
